import { Dispatch } from "redux";

import api from "@helpers/api";

import { RoomTypesStateAction } from "@reducers/types/inventory/roomTypes-state";
import {
  GET_ROOM_TYPES,
  GET_SINGLE_ROOM_TYPES,
  CREATE_ROOM_TYPES,
  UPDATE_ROOM_TYPES,
  DELETE_ROOM_TYPES,
} from "./types";

import { RoomTypesCreateType } from "@type/inventory/room-types";

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE_BASE_URL}${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE}/api/${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE_VERSION}/${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE_TYPE}/room-types`;

export const fetchRoomTypes =
  (query: any) => async (dispatch: Dispatch<RoomTypesStateAction>) => {
    dispatch({ type: GET_ROOM_TYPES.LOADING, payload: true });

    try {
      const res = await api.get(apiEndPoint, {
        params: query,
      });

      const { data, page, size, total } = res.data || {};

      dispatch({
        type: GET_ROOM_TYPES.SUCCESS,
        payload: {
          data,
          pagination: {
            page,
            size,
            total,
          },
        },
      });
    } catch (err) {
      dispatch({ type: GET_ROOM_TYPES.ERROR, payload: err });
    }
  };

// single room types

export const fetchRoomTypesDetails =
  (id: string | number) => async (dispatch: Dispatch<RoomTypesStateAction>) => {
    dispatch({ type: GET_SINGLE_ROOM_TYPES.LOADING, payload: true });

    try {
      const res = await api.get(`${apiEndPoint}/${id}`);
      const data = res.data || {};

      dispatch({
        type: GET_SINGLE_ROOM_TYPES.SUCCESS,
        payload: {
          data,
        },
      });
    } catch (err) {
      dispatch({ type: GET_SINGLE_ROOM_TYPES.ERROR, payload: err });
    }
  };

export const createRoomTypes =
  (data: RoomTypesCreateType) =>
  async (dispatch: Dispatch<RoomTypesStateAction>) => {
    dispatch({ type: CREATE_ROOM_TYPES.LOADING, payload: true });

    try {
      const res = await api.post(apiEndPoint, {
        ...data,
        isActive: true,
      });

      dispatch({ type: CREATE_ROOM_TYPES.SUCCESS, payload: res.data });
    } catch (err) {
      dispatch({ type: CREATE_ROOM_TYPES.ERROR, payload: err });
    }
  };

export const updateRoomTypes =
  (id: string | number, data: RoomTypesCreateType) =>
  async (dispatch: Dispatch<RoomTypesStateAction>) => {
    dispatch({ type: CREATE_ROOM_TYPES.LOADING, payload: true });

    try {
      const res = await api.put(`${apiEndPoint}/${id}`, {
        ...data,
      });

      dispatch({
        type: UPDATE_ROOM_TYPES.SUCCESS,
        payload: {
          ...res.data,
          name: data.name,
        },
      });
    } catch (err) {
      dispatch({ type: UPDATE_ROOM_TYPES.ERROR, payload: err });
    }
  };

export const deleteRoomTypes =
  (id: string | number) => async (dispatch: Dispatch<RoomTypesStateAction>) => {
    dispatch({ type: DELETE_ROOM_TYPES.LOADING, payload: true });

    try {
      const res = await api.delete(`${apiEndPoint}/${id}`);

      dispatch({ type: DELETE_ROOM_TYPES.SUCCESS, payload: id });
    } catch (err) {
      dispatch({ type: DELETE_ROOM_TYPES.ERROR, payload: err });
    }
  };
